module.exports = __webpack_public_path__ + "img/send_offer_message.4d904ea8.svg";